// extracted by mini-css-extract-plugin
export var caption = "ApartmentDeclaration-module--caption--Eudlj";
export var component = "ApartmentDeclaration-module--component --PB71l";
export var data = "ApartmentDeclaration-module--data--nMLsT";
export var headline = "ApartmentDeclaration-module--headline--8YRme";
export var item = "ApartmentDeclaration-module--item--G9XK3";
export var label = "ApartmentDeclaration-module--label--fFvHb";
export var list = "ApartmentDeclaration-module--list--krV9p";
export var table = "ApartmentDeclaration-module--table--iOQLS";